import { Pipe, PipeTransform } from '@angular/core'
import { environment } from 'src/environments/environment'
/**
 * image url 변경 pipe
 * 직접 s3에 접근하는 경우에 사용. (직접 s3 접근하면 http/1.1로 접근하게 되어서 속도가 느려짐)
 * s3 -> cloudfront주소로 변경시켜주는 pipe
 *
 * 그냥 assets/icons 이미지 파일의 경우 이미지를 webp형식으로 변경 + 이미지용 cloudfront로 변경.
 * 이미지 캐시가 types.my에 있으면 invalidation이 자주 일어나서 이를 막기위함. + webp로 이미지 용량 줄이기
 * ex) `${cloudfront url}/${image path}.webp`
 */
@Pipe({
  name: 'imageUrl',
})
export class ImageUrlPipe implements PipeTransform {
  constructor() {}

  // assets/icons ~ .png (png only)
  private assetPngUrlRegex = /^assets\/icons\/.*\.png$/
  private s3UrlRegex = /https:\/\/types-static(-dev)?\.s3\.[a-z0-9-]+\.amazonaws\.com/

  transform(value: string | undefined, disabled = false): string | undefined {
    if (disabled) return value
    if (!value) return value
    if (this.s3UrlRegex.test(value)) {
      return this.replaceS3Domain(value)
    }
    if (this.assetPngUrlRegex.test(value)) {
      return this.replaceAssetExtToWebp(value)
    }
    return value
  }

  private replaceS3Domain(url: string): string {
    return url.replace(/https:\/\/types-static(-dev)?\.s3\.[a-z0-9-]+\.amazonaws\.com/, environment.imageCDNUrl)
  }

  private replaceAssetExtToWebp(url: string): string {
    return url.replace('.png', '.webp')
  }
}
